import { createGlobalStyle, css } from 'styled-components';

function columnGenerator(suffix) {
	let style = '';

	for (let i = 1; i <= 12; i++) {
		style += suffix ? `.col-${suffix}-${i}` : `.col-${i}`;
		style += `{ width: ${(100 / 12) * i}% }`;
	}

	return style;
}

const HelperClass = createGlobalStyle`${css`
	/* //! Fonts */
	/* //! Larken */
	.font-larken-thin {
		font-family: var(--larken);
		font-weight: 100;
	}

	.font-larken-thin-italic {
		font-family: var(--larken);
		font-weight: 100;
		font-style: italic;
	}

	.font-larken-light {
		font-family: var(--larken);
		font-weight: 300;
	}

	.font-larken-light-italic {
		font-family: var(--larken);
		font-weight: 300;
		font-style: italic;
	}

	.font-larken-regular {
		font-family: var(--larken);
		font-weight: 400;
	}

	.font-larken-italic {
		font-family: var(--larken);
		font-weight: 400;
		font-style: italic;
	}

	.font-larken-medium {
		font-family: var(--larken);
		font-weight: 500;
	}

	.font-larken-medium-italic {
		font-family: var(--larken);
		font-weight: 500;
		font-style: italic;
	}

	/* //! FSS */
	.font-fss-light {
		font-family: var(--fss);
		font-weight: 300;
	}

	.font-fss-light-italic {
		font-family: var(--fss);
		font-weight: 300;
		font-style: italic;
	}

	.font-fss-regular {
		font-family: var(--fss);
		font-weight: 400;
	}

	.font-fss-italic {
		font-family: var(--fss);
		font-weight: 400;
		font-style: italic;
	}

	.font-fss-bold {
		font-family: var(--fss);
		font-weight: 700;
	}

	.font-fss-bold-italic {
		font-family: var(--fss);
		font-weight: 700;
		font-style: italic;
	}

	/* //! Colors */
	.green-1000 {
		color: var(--green1000);
	}

	.yellow-1000 {
		color: var(--yellow1000);
	}

	.gray-1000 {
		color: var(--gray1000);
	}

	.light-gray-1000 {
		color: var(--lightGray1000);
	}

	.white-1000 {
		color: var(--white1000);
	}

	.green-100 {
		color: var(--green100);
	}

	.error-1000 {
		color: var(--error1000);
	}

	/* //! Text line Animations */
	.text-underline-animation {
		--distanceLine: 100%;
		--heightLine: 2px;

		position: relative;
		width: fit-content;
		overflow: hidden;
		display: inline-flex;

		&::before,
		&::after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			height: var(--heightLine);
			width: 100%;
			background-color: var(--green1000);
			transition: calc(var(--trTime) * 2) ease-out;
			transform: translateX(0);
		}

		&::after {
			left: calc(-100% - var(--distanceLine));
			background-color: var(--green1000);
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					&::after,
					&::before {
						transform: translateX(calc(100% + var(--distanceLine)));
					}
				}
			}
		}
	}

	.text-underline-animation2 {
		position: relative;
		width: fit-content;
		overflow: hidden;
		display: inline-flex;

		&::after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 2px;
			background-color: var(--green1000);
			transform-origin: right;
			animation: lineAnimBefore var(--trTime) ease-out forwards;
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					&::after {
						transform-origin: left;
						animation: lineAnimAfter var(--trTime) ease-out forwards;
					}
				}
			}
		}

		@keyframes lineAnimAfter {
			0% {
				transform: scaleX(0%);
			}

			100% {
				transform: scaleX(100%);
			}
		}

		@keyframes lineAnimBefore {
			0% {
				transform: scaleX(100%);
			}

			100% {
				transform: scaleX(0%);
			}
		}
	}

	/* //! Grid */
	.row {
		display: flex;
		flex-wrap: wrap;
		margin: 0 calc(var(--colPadding) * -1);

		> * {
			width: 100%;
			padding: 0 var(--colPadding);
		}

		${columnGenerator()};

		/* //! 1920 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeXLMin}) {
			${columnGenerator('dxl')};
		}

		/* //! 1536 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeLMin}) {
			${columnGenerator('dl')};
		}

		/* //! 1366 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeMMin}) {
			${columnGenerator('dm')};
		}

		/* //! 1280 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.desktopSizeSMin}) {
			${columnGenerator('ds')};
		}

		/* //! 1024 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeMin}) {
			${columnGenerator('t')};
		}

		/* //! 768 */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeXMin}) {
			${columnGenerator('dx')};
		}

		/* //! Mobile */
		@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.tabletSizeSMin}) {
			${columnGenerator('m')};
		}
	}
`}`;

export default HelperClass;
